import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (!(window as any).stxChatbot) (window as any).stxChatbot = {};

const init = (config?: any) => {
  if (config) {
    (window as any).stxChatbot = {
      ...(window as any).stxChatbot,
      ...config
    };
  }

  console.log('STX Chatbot Init');

  const root = ReactDOM.createRoot(
    document.getElementById('stx-chatbot') as HTMLElement
  );
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

if ((window as any).stxChatbot?.auto_init) {
  init();
}
else {
  (window as any).stxChatbot.init = init;
}
